var base = {
  color: {
    "default": '#aaa',
    blue: '#2196f3',
    'dark-blue': '#02173e',
    alert: '#ff3333',
    white: '#fff'
  },
  size: {
    small: '12px',
    medium: '24px',
    large: '48px',
    xlarge: '96px'
  }
};
export var defaultProps = {
  theme: base
};